module.exports = __webpack_public_path__ + "static/media/diaper30-79.3df8361b.png";